export const getNavigatorLanguage = () => (
  window.navigator.language
)
